import { Injectable } from '@angular/core';
import { StartupInfos_ExecutionWorkflows, Model_Workflow, Model_ResponseWorkflow } from 'src/app/app.models';

@Injectable()
export abstract class WorkflowService {
    public abstract async doGetStartupInfosAction(): Promise<StartupInfos_ExecutionWorkflows>;
    public abstract async doGetWorkflowByNumAction(_numWorkflow: string): Promise<Model_Workflow>;
}